import { useMemo } from 'react';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { Charts as ChartsType } from '../../../store/financials-store/financials-store.type';
import { Filters as AllocationOfCostFilters } from './allocation-of-costs/filters';
import { Filters as CostByInitiativeFilters } from './cost-by-initiative/filters';
import { Filters as CostVersusOutputFilters } from './cost-versus-output/filters';

function Filters({ setShow }: { setShow: (show: boolean) => void }) {
  const selectedChart = useFinancialsStore((state) => state.chart);

  const filters = useMemo(() => {
    switch (selectedChart) {
      case ChartsType.AllocationOfCosts:
        return <AllocationOfCostFilters setShow={setShow} />;
      case ChartsType.CostVersusOutput:
        return <CostVersusOutputFilters setShow={setShow} />;
      default:
        return <CostByInitiativeFilters setShow={setShow} />;
    }
  }, [selectedChart, setShow]);

  return filters;
}

export { Filters };
